import cronstrue from 'cronstrue';

export const handleCronChange = (cronValue) => {
	const parts = cronValue.split(' ');
	const monthIndex = parts.length - 2;

	if (parts[monthIndex] !== '*') {
		parts[monthIndex] = modifyMonth(parts[monthIndex], -1);
	}

	return parts.join(' ');
};

export const handleDisplayCron = (storedValue) => {
	if (!storedValue) {
		return;
	}

	const parts = storedValue.split(' ');
	if (parts.length > 5) {
		parts.shift();
	}

	const monthIndex = parts.length - 2;
	if (parts[monthIndex] !== '*') {
		parts[monthIndex] = modifyMonth(parts[monthIndex], 1);
	}

	return parts.join(' ');
};

const modifyMonth = (month, delta) => {
	return month.replace(/(?<!\/)\d+/g, (match) => {
		return String(parseInt(match, 10) + delta);
	});
};

export const getCronDescription = (cronTime) => {
	let cronTimeDescription = '';
	try {
		const parts = cronTime.split(' ');
		if (parts.length > 5) {
			parts.shift();
		}
		cronTime = parts.join(' ');

		cronTimeDescription = cronstrue.toString(cronTime, {
			use24HourTimeFormat: true,
		});
	} catch {
		cronTimeDescription = '---------';
	}
	return cronTimeDescription;
};
